import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { blogCategories } from 'lib/contentful-client';
const Nav = t0 => {
  const $ = _c(11);
  const {
    blogUrl,
    slug
  } = t0;
  const t1 = `/${blogUrl}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-xl font-bold text-gray items-center hidden h-[58px] m-0 lg:flex lg:h-20 lg:mr-[4vw]">The Blog</p>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <Link to={t1}>{t2}</Link>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== blogUrl || $[4] !== slug) {
    t4 = blogCategories.map(nav => <li key={`${nav.slug}-navlink`} className="text-base flex flex-shrink-0 items-center justify-center font-bold no-underline cursor-pointer h-[58px] lg:h-20 [&_a]:[border-bottom:1px_solid_transparent] [&_a]:items-center [&_a]:content-center [&_a]:h-full [&_a]:transition-[all_.15s_ease-in] [&_a]:pl-3 [&_a]:pr-3 [&_a]:mb-0.5"><Link to={`/${blogUrl}${nav.slug ? `${nav.slug}/` : ""}`} className={classNames("flex hover:text-brand hover:shadow-[0_1px_0_0_theme(colors.brand.DEFAULT)]", {
        "text-inherit": slug !== nav.slug,
        "text-brand shadow-[0_1px_0_0_theme(colors.brand.DEFAULT)]": slug === nav.slug
      })}>{nav.text}</Link></li>);
    $[3] = blogUrl;
    $[4] = slug;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <ul className="flex h-full overflow-x-auto m-0 pl-3 pr-3 lg:mx-4 lg:my-0 lg:p-0 [&::-webkit-scrollbar]:hidden">{t4}</ul>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <nav className="flex items-baseline [border-bottom:1px_solid_#f1f1f1] lg:pl-[3.333vw] lg:pr-[3.333vw]">{t3}{t5}</nav>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
Nav.propTypes = {
  blogUrl: PropTypes.string,
  slug: PropTypes.string
};
export default Nav;